/**
 * Content manager script to keep all local content in one place
 * Replace with headless CMS later
 */

import orthoDiagnoses from '@/content/ortho/diagnoses'
import inputTypes from '@/content/logbook/input-types'
import treeCategories from '@/content/logbook/tree-categories'
import sides from '@/content/logbook/sides'
import sexes from '@/content/logbook/sexes'
import priorities from '@/content/logbook/priorities'
import complications from '@/content/logbook/complications'
import ORLProcedures from '@/content/logbook/orl-procedures'
import ORLAnatomicAreas from '@/content/logbook/orl-anatomic-areas'
import scientificActivityTypes from '@/content/scientific-activity/types'
import scientificActivitySubTypesPublication from '@/content/scientific-activity/subTypesPublication'
import scientificActivitySubTypesPresentation from '@/content/scientific-activity/subTypesPresentation'
import scopesPresentationType from '@/content/scientific-activity/scopesPresentationType'
import typesOfPublication from '@/content/scientific-activity/typesOfPublication'
import courseTypes from '@/content/course/types'
import courseSubTypes from '@/content/course/subtypes'
import praticalSubTypes from '@/content/course/practical-subtypes'
import praticalSubTypesOphthamology from '@/content/course/practical-subtypes-ophthamology'
import diagnoses from '@/content/logbook/diagnoses'
import roles from '@/content/profile/roles'
import hospitals from '@/content/profile/hospitals'
import specialties from '@/content/profile/specialties'
import rotations from '@/content/internship/rotations'
import status from '@/content/internship/status'
import internships from '@/content/internship/internships'
import logotypes from '@/content/logotypes/logotypes'
import durationOptions from '@/content/stats/durationOptions'

export default {
  orthoDiagnosisNames(lang = 'en') {
    return mapWithLanguage(lang, orthoDiagnoses)
  },
  getSpecialties(lang = 'en') {
    return mapWithLanguage(lang, specialties)
  },
  getSpecialtyById(id, lang = 'en') {
    return (specialties.find(s => s.id === id) || {})[lang]
  },
  getRoles(lang = 'en') {
    return mapWithLanguage(lang, roles)
  },
  getHospitals() {
    return hospitals.map(hospital => {
      return { text: hospital.name, value: hospital.id }
    })
  },
  getHospitalName(hospitalId) {
    const hospital = this.getHospitals().find(h => h.value === hospitalId)
    return hospital ? hospital.text : undefined
  },
  getlogotypes() {
    return logotypes
  },
  getInternships(lang = 'en') {
    return mapWithLanguage(lang, internships)
  },
  getRotations(lang = 'en') {
    return mapWithLanguage(lang, rotations)
  },
  getStatus(lang = 'en') {
    return mapWithLanguage(lang, status)
  },
  getSides(lang = 'en') {
    return mapWithLanguage(lang, sides)
  },
  getSexes(lang = 'en') {
    return mapWithLanguage(lang, sexes)
  },
  getPriorities(lang = 'en') {
    return mapWithLanguage(lang, priorities)
  },
  getORLAnatomicAreas(lang = 'en') {
    return mapWithLanguage(lang, ORLAnatomicAreas)
  },
  getORLComplications(lang = 'en') {
    return mapWithLanguage(lang, complications)
  },
  getORLProcedures(lang = 'en') {
    return mapWithLanguage(lang, ORLProcedures)
  },
  getScientificActivitiesTypes(lang = 'en') {
    return mapWithLanguage(lang, scientificActivityTypes)
  },
  getScientificActivitiesSubTypesPublication(lang = 'en') {
    return mapWithLanguage(lang, scientificActivitySubTypesPublication)
  },
  getScientificActivitiesSubTypesPresentation(lang = 'en') {
    return mapWithLanguage(lang, scientificActivitySubTypesPresentation)
  },
  getScopesPresentationType(lang = 'en') {
    return mapWithLanguage(lang, scopesPresentationType)
  },
  getCourseTypes(lang = 'en') {
    return mapWithLanguage(lang, courseTypes)
  },
  getCourseSubTypes(lang = 'en') {
    return mapWithLanguage(lang, courseSubTypes)
  },
  getCoursePracticalSubTypes(lang = 'en') {
    return mapWithLanguage(lang, praticalSubTypes)
  },
  getCoursePracticalSubTypesOphthamology(lang = 'en') {
    return mapWithLanguage(lang, praticalSubTypesOphthamology)
  },
  getDiagnoses(lang = 'en') {
    return mapWithLanguage(lang, diagnoses)
  },
  getInputTypes(lang = 'en') {
    return mapWithLanguage(lang, inputTypes)
  },
  getTypesOfPublication(lang = 'en') {
    return mapWithLanguage(lang, typesOfPublication)
  },
  getTree(lang = 'en') {
    return getTreeBranchs(lang, treeCategories)
  },
  getDurationOptions() {
    return durationOptions
  }
}

function mapWithLanguage(lang, list) {
  return list.map(s => {
    let entry = {}

    entry.text = s[lang]
    entry.value = s.id
    return entry
  })
}

function getTreeBranchs(lang, tree) {
  return tree.map(c => {
    let treeBranch = {}

    treeBranch.value = c.id
    treeBranch.text = c[lang]
    treeBranch.multipleOptions = c.multipleOptions ? c.multipleOptions : false
    treeBranch.hasNumericInput = c.hasNumericInput ? c.hasNumericInput : false
    treeBranch.maxOptions = c.maxOptions ? c.maxOptions : null

    if (c.children && c.children.length) {
      treeBranch.children = getTreeBranchs(lang, c.children)
    }

    return treeBranch
  })
}
